import React, { useState, useEffect, useRef, useMemo } from 'react'
import classnames from 'classnames'
import moment from 'moment'
import Button from 'meinian-package/src/baseComponent/button'
import { ossImg } from 'meinian-package/src/utils/image'
import Textarea from 'meinian-package/src/baseComponent/textarea'
import Upload from 'meinian-package/src/component/upload/image'
import Icon from 'meinian-package/src/component/icon'
import PicturePreview from '../../../../baseComponent/perViewImg'
import { hasAnnotationAuth } from '../detailAuth'
import './note.less'

const MAX_UPLODA_SIZE = 10// m

export const NoteLabel = ({ data = {}, index, }) => {
  return <div
    className={classnames('mn-note-wrapper-label')}
    style={{
      right: `${100 - data.xmax * 100}%`,
      bottom: `${100 - data.ymax * 100}%`,
    }}
  >
    <span className="mn-note-wrapper-label-index">{index}</span>
  </div>
}
const wrapWidth = 338
const maxWrapHeight = 388
const wrapPadding = 12
const wrapIndexSize = 32
export default (props) => {
  const {
    data = {},
    index,
    active,
    showNote,
    onOk,
    onCancel,
    onMouseDown,
    canMove,
    onEdit,
    onDelete,
    imagePosition,
    loginUserInfo,
    root
  } = props
  const [currentNote, setCurrentNote] = useState(data)
  const $textarea = useRef()
  const [placement, setPlacement] = useState('rightTop')
  const [wrapHeight, setWrapHeight] = useState(maxWrapHeight)
  const curNoteDom = useRef()

  useEffect(() => {
    if (curNoteDom.current?.clientHeight) {
      setWrapHeight(curNoteDom.current?.clientHeight)
    } else {
      setWrapHeight(maxWrapHeight)
    }
  }, [curNoteDom.current?.clientHeight, data.confirm, data.editMode, showNote])

  useEffect(() => {
    if ((showNote && active && !data.confirm) || (data.confirm && data.editMode && showNote && active)) {
      $textarea.current.$textarea.focus()
    }
  }, [showNote, data.editMode])

  useEffect(() => { setCurrentNote(data) }, [data])

  useEffect(() => {
    const rootSize = {
      width: root.current?.clientWidth,
      height: root.current?.clientHeight
    }
    const _curPosition = {
      top: imagePosition.height * data.ymax + imagePosition.top,
      left: imagePosition.width * data.xmax + imagePosition.left,
    }
    onPlacement(_curPosition, rootSize)
  }, [root.current, imagePosition, data.ymax, data.xmax, wrapHeight])

  const placementStyle = useMemo(() => {
    const temp = {
      leftBottom: {
        left: -(wrapWidth + wrapPadding),
        top: -(wrapPadding / 2),
      },
      rightTop: {
        left: wrapPadding + wrapIndexSize,
        top: -(wrapHeight - wrapIndexSize),
      },
      leftTop: {
        left: -(wrapWidth + wrapPadding),
        top: -(wrapHeight - wrapIndexSize),
      },
      rightBottom: {
        left: wrapIndexSize + wrapPadding,
        top: -(wrapPadding / 2),
      }
    }
    return temp[placement]
  }, [placement, wrapHeight])

  const onPlacement = (curPosition, rootSize) => {
    let _placement = 'rightTop'
    if (curPosition.left + wrapWidth > rootSize.width && curPosition.top + wrapHeight > rootSize.height) {
      _placement = 'leftTop'
    } else if (curPosition.left + wrapWidth < rootSize.width && curPosition.top + wrapHeight < rootSize.height) {
      _placement = 'rightBottom'
    } else if (curPosition.left + wrapWidth > rootSize.width && curPosition.top + wrapHeight < rootSize.height) {
      _placement = 'leftBottom'
    } else if (curPosition.left + wrapWidth < rootSize.width && curPosition.top + wrapHeight > rootSize.height) {
      _placement = 'rightTop'
    }
    setPlacement(_placement)
  }
  const auth = loginUserInfo?.inspirationPermissions || []
  return <div
    key={index}
    className={classnames('mn-note-wrapper', { active, movable: canMove })}
    style={{
      top: `${data.ymin * 100}%`,
      right: `${100 - data.xmax * 100}%`,
      bottom: `${100 - data.ymax * 100}%`,
      left: `${data.xmin * 100}%`,
      zIndex: active ? '777' : index + 10
    }}
    onMouseDown={e => onMouseDown?.(data, e)}
    onTouchStart={e => onMouseDown?.(data, e)}
  >
    <div className="index">
      <span>{index}</span>
      {showNote ? <div
        style={placementStyle}
        className={classnames('note-container')}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        key={index}
      >
        <div className={classnames('note', { [placement]: true })} ref={curNoteDom}>
          <div className="note-right">
            {
              data?.userName && <div className="note-header-line">
                <img src={data?.avatar} alt="" className="note-avatar" />
                <div className="user-info">
                  {data?.userName}
                </div>
              </div>
            }
            {
              (data?.confirm && !data.editMode) ? <div className="confirm-content">
                {data?.annotationContent && <div className="content-detail">{data?.annotationContent}</div>}
                {data?.annotationUrl && <div
                  className="detail-img-bg"
                  onMouseDown={(e) => {
                    e.stopPropagation()
                    PicturePreview.show({ src: data?.annotationUrl, picWidth: data?.width, picHeight: data?.height })
                  }}
                  onTouchStart={(e) => {
                    e.stopPropagation()
                    PicturePreview.show({ src: data?.annotationUrl, picWidth: data?.width, picHeight: data?.height })
                  }}
                  style={{ backgroundImage: `url(${data?.annotationUrl})` }}
                />}
                {data?.createdAt && <div className="annotate-time">{moment(data?.createdAt).format('YYYY-MM-DD HH:mm')}</div>}
              </div> : <>
                <Textarea
                  wrapClassName="annotate-input"
                  placeholder="点击输入批注内容"
                  maxLength={150}
                  minHeight={170}
                  readOnly={data.confirm && !data.editMode}
                  value={currentNote?.annotationContent || ''}
                  onInput={e => setCurrentNote(pre => ({ ...pre, annotationContent: e.target.value }))}
                  suffix={<div className="suffix">{`${currentNote?.annotationContent?.length || 0}/150`}</div>}
                  id={`annotate-input-${index}`}
                  ref={$textarea}
                  onMouseDown={e => e.stopPropagation()}
                  onTouchStart={e => e.stopPropagation()}
                />
                <div className="annotate-upload">
                  <Upload
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                    disabled={data.confirm && !data.editMode}
                    onSuccess={file => setCurrentNote(pre => ({ ...pre, annotationUrl: file?.[0]?.url }))}
                    maxSize={MAX_UPLODA_SIZE}
                  >
                    <a className="cover" onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()}>
                      {currentNote?.annotationUrl ? <div className="re-upload">
                        <img className="re-upload-image" src={ossImg(currentNote?.annotationUrl, 600)} />
                        <span>
                          <span className="re-upload-replace fill-white-bg">更换</span>
                          <span className="re-upload-clear fill-white-bg" onClick={(e) => { e.preventDefault(); setCurrentNote(pre => ({ ...pre, annotationUrl: '' })) }}>清除</span>
                        </span>
                      </div> : <div className="upload-tip-container">
                        <Icon type="m-tianjia_miaobian" className="upload-icon" />
                        <div className="upload-tip">添加图片批注</div>
                      </div>}
                    </a>
                  </Upload>
                </div>
              </>
          }
            <div className="annotate-operation">
              {(data.editMode || !data.confirm) && <>
                <Button
                  className="annotate-operation-btn"
                  style={{ marginRight: '8px' }}
                  onMouseDown={(e) => {
                    e.stopPropagation()
                    onCancel && onCancel(data, e)
                  }}
                >取消</Button>
                <Button
                  type="primary"
                  className="annotate-operation-btn"
                  onMouseDown={e => onOk && onOk({ ...data,
                    annotationContent: currentNote?.annotationContent,
                    annotationUrl: currentNote?.annotationUrl
                  }, e)}
                >完成</Button>
                </>}
              {(data.confirm && !data.editMode) && hasAnnotationAuth(auth, currentNote.userId) && <>
                <Button className="annotate-operation-btn" onMouseDown={e => onDelete && onDelete(data, e)} style={{ marginRight: '8px' }}>删除</Button>
                <Button className="annotate-operation-btn" type="primary" onMouseDown={e => onEdit && onEdit(data, e)}>修改</Button>
                </>}
            </div>
          </div>
        </div>
      </div> : null}
    </div>
  </div>
}
